import { Injectable, inject } from '@angular/core';
import { StatusBar, StatusBarInfo } from '@capacitor/status-bar';
import { PlatformService } from './platform.service';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StatusBarService {
  private readonly platformService = inject(PlatformService);

  private backgroundColor: string = '#000000';

  public getInfo(): Promise<StatusBarInfo> {
    return StatusBar.getInfo();
  }

  public async setBackgroundColor(): Promise<void> {
    //if (!this.platformService.isAndroidApp) return;

    await StatusBar.setBackgroundColor({color: this.backgroundColor});
  }

  public async activateOverlays(): Promise<void> {
    if(!environment.useStatusBarOverlays) return;

    await this.setOverlays(true);
  }

  public async deactivateOverlays(): Promise<void> {
    if(!environment.useStatusBarOverlays) return;

    await this.setOverlays(false);
    await this.setBackgroundColor();
  }

  private async setOverlays(activate: boolean): Promise<void> {
    if (!this.platformService.isAndroidApp) return; //TODO новый капаситор 7 поддерживает setOverlaysWebView

    try {
      await StatusBar.setOverlaysWebView({overlay: activate});
    } catch (error) {
      console.error('Error setting status bar overlay:', error);
    }
  }
}
